import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector} from "react-redux";

import api from "helpers/api";
import style from "./ClientBook.module.scss";
import Loader from "components/miscellaneous/Loader/Loader";
import ChooseService from "./Steps/ChooseService/ChooseService";
import PersonalDetails from "./Steps/PersonalDetails/PersonalDetails";
import BookingConfirmation from "./Steps/BookingConfirmation/BookingConfirmation";
import ModifyBooking from "./Steps/ModifyBooking/ModifyBooking";

const ClientBook = () => {
    const params = useParams();
    const [ clinicId, setClinicId ] = useState(null);
    const [ clinic, setClinic ] = useState(null);
    const [ token, setToken ] = useState(null);
    const [ appointment, setAppointment ] = useState(null);
    const [ activeStep, setActiveStep ] = useState(1)
    const [ isLoading, setIsLoading ] = useState(true);
    const [ payload, setPayload ] = useState({})
    const user = useSelector(state => state.auth.user)

    const steps = [
        { component: ChooseService },
        { component: PersonalDetails },
        { component: BookingConfirmation }
    ]

    useEffect(() => {
        if (params.token) {
            setAppointment(null);
            setToken(params.token);
        }

        if (params.clinicId) {
            setClinic(null)
            setClinicId(params.clinicId)
        }
    }, [ params ]);

    useEffect(() => {
        if (clinicId !== null) {
            getClinic()
        }
    }, [ clinicId ]);

    useEffect(() => {
        if (token !== null) {
            getAppointment()
        }
    }, [ token ]);

    useEffect(() => {
        if (appointment !== null && appointment !== false) {
            setPayload(getPayloadFromAppointment())
            setActiveStep(steps.length)
        }
    }, [ appointment ])

    const getClinic = async () => {
        setIsLoading(true)
        try {
            const res = await api.get(`/booking/verify/clinic/${clinicId}`);
            if (res.success && res.data.success) {
                setClinic(res.data.data);
            }
        } catch (e) {
            setClinic(false)
        } finally {
            setIsLoading(false)
        }
    }

    const getAppointment = async () => {
        setIsLoading(true)
        try {
            const res = await api.get(`/booking/${token}`);
            if (res.success && res.data.success) {
                setAppointment(res.data.data);
            } else {

            }
        } catch (e) {
            setAppointment(false)
        } finally {
            if (clinic !== null) {
                setIsLoading(false)
            }
        }
    }

    const getPayloadFromAppointment = () => {
        return {
            agreeToSMS: appointment.agree_to_sms,
            date: appointment.scheduled_at,
            email: appointment.customer_email,
            firstName: appointment.customer_first_name,
            lastName: appointment.customer_last_name,
            phone: appointment.customer_phone,
            service: appointment.service,
            service_options: [],
            staff: appointment.staff_id,
            staffName: appointment.staff !== null ? appointment.staff.name : null,
            tos: true
        }
    }


    const completeStep = (stepNumber) => {
        setActiveStep(stepNumber + 1)
    }

    return (<>
        <div className={ [style.wrapper, user && style.wrapperApp].join(' ') }>
            { isLoading || clinic === null ? <div className={ style.loading }>
                <Loader color="#ddd" />
            </div> : <>
                <div className={ style.container }>
                    { appointment === null ? <>
                        <div className={ style.header }>
                            <h1>{ clinic.name }</h1>
                            <p>Schedule an Appointment</p>
                        </div>

                        { steps.map((s, i) => {
                            const stepNumber = i + 1;
                            const StepComponent = s.component;

                            return (
                                <StepComponent clinic={ clinic } show={ activeStep === stepNumber ? true : false } number={ stepNumber } complete={ (num = null, data = null) => {
                                    completeStep(num === null ? stepNumber : num)
                                    if (data !== null) {
                                        setPayload({ ...payload, ...data })
                                    }
                                } } payload={ payload } appointment={ appointment } />
                            )
                        }) }
                    </> : <ModifyBooking clinic={clinic} payload={payload} appointment={appointment} /> }
                </div>
            </> }
        </div>
    </>)
}

export default ClientBook;